import { useCallback, useEffect } from 'react'

import { useAtom } from 'jotai'

import { toggleLivechat } from './toggle-live-chat-atom'
import type { LivechatMainButton } from './types'

export const useLiveChatWidgetWithoutMainButton = (
  hideChatWidget?: boolean
) => {
  const [isLivechatOpen, setLivechatState] = useAtom(toggleLivechat)

  const mainButton: LivechatMainButton =
    typeof window !== 'undefined'
      ? document.querySelector('[data-component-name="mainButton"]')
      : null

  const hideWidgetMainButton = () => {
    if (mainButton) {
      mainButton.style.display = 'none'
    }
  }

  const openChat = useCallback(() => {
    if (mainButton) {
      mainButton.click()
    }
  }, [mainButton])

  useEffect(() => {
    if (!hideChatWidget || !window.daktelaGui || !isLivechatOpen) {
      return
    }

    openChat()

    const closeButton: LivechatMainButton = document.querySelector(
      '#daktela-web-header-hide'
    )

    if (closeButton) {
      const handleHide = () => {
        setLivechatState(false)
      }

      closeButton.addEventListener('click', handleHide)

      return () => {
        closeButton.removeEventListener('click', handleHide)
      }
    }
  }, [isLivechatOpen, hideChatWidget, setLivechatState, openChat])

  return { hideWidgetMainButton, openChat }
}
